import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-signpost",
  "use": "icon-th-signpost-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-signpost\">\n<path d=\"M30.75 13.3313L26.25 8.33125C26.1555 8.22617 26.0398 8.14232 25.9105 8.08523C25.7812 8.02813 25.6413 7.99908 25.5 8H17V4C17 3.73478 16.8946 3.48043 16.7071 3.29289C16.5196 3.10536 16.2652 3 16 3C15.7348 3 15.4804 3.10536 15.2929 3.29289C15.1054 3.48043 15 3.73478 15 4V8H5C4.46957 8 3.96086 8.21071 3.58579 8.58579C3.21071 8.96086 3 9.46957 3 10V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H15V28C15 28.2652 15.1054 28.5196 15.2929 28.7071C15.4804 28.8946 15.7348 29 16 29C16.2652 29 16.5196 28.8946 16.7071 28.7071C16.8946 28.5196 17 28.2652 17 28V20H25.5C25.6403 20 25.779 19.9706 25.9071 19.9135C26.0352 19.8564 26.1499 19.773 26.2437 19.6688L30.7437 14.6687C30.9098 14.4859 31.0022 14.2481 31.0034 14.0012C31.0045 13.7543 30.9143 13.5156 30.75 13.3313ZM25.055 18H5V10H25.055L28.655 14L25.055 18Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-signpost.svg
// module id = 9oBO
// module chunks = 84